import React, { FC, useCallback, useState } from 'react'

import { FlashMessageSpacer, FlashMessageWrapper, FlashMessageContent, FlashMessageContentIcon, FlashMessageContentMessage, FlashMessageContentTitle, FlashMessageDismiss, FlashMessageLink, FlashMessageContentTitleWrapper } from "./flash-message.styles"
import { FLASH_MESSAGES } from "./constants"
import CloseIcon from "../icons/svg/close-icon"
import CaretRightIcon from "../icons/svg/caret-right-icon"

interface FlashMessageProps {
    flashMessage?: string
}

const FlashMessage: FC<FlashMessageProps> = ({ flashMessage }) => {
    const [dismissed, setDismissed] = useState(false)
    const dismissCallback = useCallback(() => {
        setDismissed(true)
    }, [])

    if (!flashMessage) return null
    const flashMessageData = FLASH_MESSAGES[flashMessage]

    if (dismissed || !flashMessageData) return null

    return <FlashMessageWrapper gradientColors={flashMessageData.gradientColors} textColor={flashMessageData.textColor}>
        <FlashMessageSpacer />

        <FlashMessageContent>
            <FlashMessageContentTitleWrapper>
                <FlashMessageContentIcon>
                    {flashMessageData.icon}
                </FlashMessageContentIcon>
                <FlashMessageContentTitle>
                    {flashMessageData.title}
                </FlashMessageContentTitle>
            </FlashMessageContentTitleWrapper>
            <FlashMessageContentMessage>
                {flashMessageData.message}
            </FlashMessageContentMessage>
            <FlashMessageLink href={flashMessageData.linkURL}>
                {flashMessageData.linkText} <CaretRightIcon width={15} height={15} />
            </FlashMessageLink>
        </FlashMessageContent>

        <FlashMessageDismiss onClick={dismissCallback}>
            <CloseIcon width={25} height={25} />
        </FlashMessageDismiss>
    </FlashMessageWrapper>
}

export default FlashMessage
